import { Amplify } from 'aws-amplify';
import {
  signIn as _signIn,
  signUp as _signUp,
  confirmSignIn as _confirmSignIn,
  confirmSignUp as _confirmSignUp,
  resetPassword as _resetPassword,
  resendSignUpCode as _resendSignUpCode,
  fetchMFAPreference as _fetchMFAPreference,
  updateMFAPreference as _updateMFAPreference,
  confirmResetPassword as _confirmResetPassword,
} from 'aws-amplify/auth';

import outputs from '../../../../amplify_outputs.json';

Amplify.configure(outputs);

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ username, password }) => {
  try {
    const result = await _signIn({ username, password });
    console.log('Sign-in successful:', result);
    return result;
  } catch (error) {
    console.error('Sign-in failed:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async ({ username, password, firstName, lastName }) => {
  await _signUp({
    username,
    password,
    options: { userAttributes: { email: username, given_name: firstName, family_name: lastName } },
  });
};

/** **************************************
 * Confirm sign up
 *************************************** */
export const confirmSignUp = async ({ username, confirmationCode }) => {
  await _confirmSignUp({ username, confirmationCode });
};

/** **************************************
 * Resend code sign up
 *************************************** */
export const resendSignUpCode = async ({ username }) => {
  await _resendSignUpCode({ username });
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async () => {
  console.log('Signing out...');

  try {
    console.log('_signOut is being called...');
    // await _signOut();

    console.log('_signOut completed successfully.');

    console.log('Signed out. Clearing cookies...');

    const cookies = document.cookie.split(';');
    console.log('Cookies:', cookies);

    cookies.forEach((cookie) => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=localhost`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;

      console.log(`Cleared cookie: ${name}`);
    });

    console.log('All cookies cleared.');
  } catch (error) {
    console.error('Error during sign out:', error);
  }
};

/** **************************************
 * Reset password
 *************************************** */
export const resetPassword = async ({ username }) => {
  const result = await _resetPassword({ username });
  console.log(result);
};

/** **************************************
 * Update password
 *************************************** */
export const updatePassword = async ({ username, confirmationCode, newPassword }) => {
  await _confirmResetPassword({ username, confirmationCode, newPassword });
};

/** **************************************
 * Confirm sign in
 *************************************** */
export const confirmSignIn = async ({ challengeResponse }) => {
  const result = await _confirmSignIn({ challengeResponse });
  return result;
};

/** **************************************
 * Fetch MFA preference
 *************************************** */
export const fetchMFAPreference = async () => {
  const { enabled, preferred } = await _fetchMFAPreference();
  return { enabled, preferred };
};

/** **************************************
 * Update MFA preference
 *************************************** */
export const updateMFAPreference = async ({ email }) => {
  await _updateMFAPreference({ email });
};
